<template>
  <div>
    <div class="circle-state" v-if="service === 'EC2'" :class="{ green: state === 'running', orange: (state === 'pending' || state === 'shutting-down' || state === 'stopping'), red: (state === 'terminated' || state === 'stopped' ) }"></div>
    <div class="circle-state" v-if="service === 'WS'" :class="{ green: state === 'available', orange: (state !== 'available' && state !== 'stopped'), red: (state === 'stopped') }"></div>
  </div>
</template>
<script>
export default {
  name: 'CircleState',
  props: ['service', 'state']
}
</script>
<style lang="scss" scoped>
div{
  display: inline-block;
  .circle-state {
  width: 15px; height: 15px;
  border-radius: 15px;
  display: inline-block;

    &.red{
      background-color: rgb(230, 50, 50);
    }
    &.orange{
      background-color: rgb(230, 167, 50);
    }
    &.green{
      background-color: rgb(50, 230, 65);
    }
  }
}
</style>
